import OSS from 'ali-oss';
import { getStsToken } from '@/axios/service/common';
import { nanoid } from 'nanoid';
import store from '@/store';
import to from 'await-to-js';

export const getOssStsToken = async ({ fileType, hideMessage, specifiedDir, sessionId, showLoading }) => {
	const orgId = store.getters.userInfo?.organizationId;
	console.log('🚀 ~ orgId:', store.getters.userInfo);
	const newSessionId = sessionId || nanoid();
	const [err, response] = await to(
		getStsToken(
			{ fileType, companyId: orgId, specifiedDir, sessionId: newSessionId },
			{ hideMessage, headers: { showLoading } }
		)
	);
	if (err) return Promise.reject(err);
	console.log('🚀 ~ response:', response);
	return {
		originSessionId: newSessionId,
		...response.data
	};
};
/**
 * @description 阿里云OSS实例
 * @param {Object} param0
 * @param {String} param0.fileType 文件类型
 * @param {Boolean} param0.hideMessage 是否隐藏消息
 * @param {String} param0.specifiedDir 指定目录
 * @returns {Object}
 * @returns {String} ObjectPre 对象前缀
 * @returns {Object} callback 回调
 * @returns {OSS} client 客户端
 */
export const OssInstance = async ({
	fileType = 'irm-public',
	hideMessage = false,
	specifiedDir = '',
	sessionId,
	showLoading = false
} = {}) => {
	const res = await getOssStsToken({ fileType, hideMessage, specifiedDir, sessionId, showLoading });
	const {
		originSessionId,
		endpoint,
		bucket,
		ObjectPre,
		AccessKeyId,
		AccessKeySecret,
		SecurityToken,
		callback,
		accessUrl,
		accelerateAccessUrl
	} = res;
	const region =
		accelerateAccessUrl?.match(/oss-[a-z0-9-]+(?=\.)/)?.[0] || endpoint?.match(/oss-[a-z0-9-]+(?=\.)/)?.[0];

	const client = new OSS({
		region,
		bucket,
		accessKeyId: AccessKeyId,
		accessKeySecret: AccessKeySecret,
		stsToken: SecurityToken, // authorizationV4: true,
		refreshSTSToken: async () => {
			const res = await getOssStsToken({ fileType, hideMessage, specifiedDir });
			const { AccessKeyId, AccessKeySecret, SecurityToken } = res;
			return {
				accessKeyId: AccessKeyId,
				accessKeySecret: AccessKeySecret,
				stsToken: SecurityToken
			};
		}
	});
	return {
		ObjectPre,
		callback,
		client,
		sessionId: originSessionId,
		accessUrl
	};
};
/**
 * @description 阿里云OSS上传
 * @param {Object} param0
 * @param {File} param0.file 文件
 * @param {Boolean} param0.isPrivate 是否私有
 * @param {Boolean} param0.hideMessage 是否隐藏消息
 * @param {String} param0.specifiedDir 指定目录
 * @param {Number} param0.limitSize 切片限制大小，超过则切片上传，否则普通上传，默认为5M
 * @param {Number} param0.partSize 分片大小，默认为1M
 * @param {Function} param0.onProgress 上传进度
 */
export const AliOssUpload = async ({
	file,
	isPrivate = false,
	hideMessage = false,
	showLoading = false,
	specifiedDir = '', // 目前私有文件才有用，公有文件不传
	limitSize = 1024 * 1024 * 1,
	partSize = 1024 * 1024,
	onProgress,
	originName
}) => {
	console.log('🚀 ~ specifiedDir:', specifiedDir);
	const fileType = isPrivate ? 'irm-private' : 'irm-public';
	const { ObjectPre, callback, client } = await OssInstance({
		fileType,
		hideMessage,
		specifiedDir,
		showLoading
	});

	try {
		const { name: fileName, size: fileSize } = file;
		const e_fileName = originName || fileName;
		const options = {
			// 获取分片上传进度、断点和返回值。
			progress: (p, cpt, res) => {
				onProgress && onProgress(p, cpt, res);
			},
			// 设置并发上传的分片数量。
			parallel: 4,
			// 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
			partSize
		};

		// 上传结果
		let uploadResult = null;
		// 回调参数
		const callbackParams = callback
			? {
					url: callback.callbackUrl,
					body: callback.callbackBody,
					contentType: callback.callbackBodyType
				}
			: undefined;
		console.log('🚀 ~ callbackParams:', callbackParams);
		// 文件大于5M 分片上传，否则普通上传
		if (fileSize > limitSize) {
			// 分片上传
			const result = await client.multipartUpload(ObjectPre + e_fileName, file, {
				...options,
				callback: callbackParams
			});
			console.log('🚀 ~multipartUpload result:', result, result.data);
			uploadResult = result.data;
		} else {
			// 普通上传
			const result = await client.put(ObjectPre + e_fileName, file, {
				callback: callbackParams
			});
			uploadResult = result.data;
			console.log('🚀 ~Upload result:', result, result.data);
		}
		return {
			fileName: e_fileName,
			viewurl: uploadResult.viewurl
		};
	} catch (error) {
		console.log(error);
		// 抛出异常，让上层捕获
		throw error;
	}
};
